export default __webpack_public_path__ + "static/media/slusanost.414b4b9d.jpg";